import { Box, Grid, Link, Typography, useTheme } from "@mui/material";
import { Command } from "~/components/guides/components/command";
import { Markdown } from "~/components/markdown";
import { useToken } from "~/providers/token";
import { formatTokenExpiration, getLinuxInstallCommand } from "./utils";
import { IntegrationAddHeader } from "../../headers/IntegrationAddHeader";
import { getIntegrationAddHeaderData } from "../../headers/utils";
import { OtherIntegrations } from "../../headers/types";
import { LINUX_SCAN_COMMAND } from "~/pages/integrations/os/linux/constants";

export const LinuxIntegrationSetupPage = () => {
  const theme = useTheme();
  const { token, refreshToken, tokenTimeLeft } = useToken();
  const linuxInstallCommand = getLinuxInstallCommand(token?.value ?? "");

  const linuxDocsLink = getIntegrationAddHeaderData(
    OtherIntegrations.LINUX,
  ).docsLink;

  return (
    <Box>
      <IntegrationAddHeader type={OtherIntegrations.LINUX} />

      <Box>
        {/* <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
          Some copy that describes all of the different Linux distributions that
          we have. To learn about all of the Linux distributions that we
          support,
          <Link
            href={linuxDocsLink}
            target="_blank"
            rel="noopener noreferrer"
            sx={{ textDecoration: "none" }}
          >
            {" "}
            read the Mondoo Documentation
          </Link>
          .
        </Typography> */}

        <Box sx={{ mt: 3 }}>
          <Box sx={{ mb: 2 }}>
            <Command
              number={1}
              options={{
                fontSize: { xs: 16 },
                dotColor: theme.palette.background.lightest,
              }}
            >
              Install cnspec on your Linux host
            </Command>
          </Box>
          <Box sx={{ pl: 6, mb: 5 }}>
            <Typography variant="body1" color="text.secondary" sx={{ mb: 1 }}>
              Install cnspec by running these commands as root
            </Typography>
            <Markdown source={`\`\`\`bash\n${linuxInstallCommand}\n\`\`\``} />
            <Typography
              variant="caption"
              color="text.secondary"
              sx={{ ml: 2, mt: -1, display: "block" }}
            >
              Your Mondoo Registration Token expires in{" "}
              {formatTokenExpiration(tokenTimeLeft)}.{" "}
              <Link
                component="button"
                onClick={refreshToken}
                sx={{
                  color: "primary.light",
                  verticalAlign: "inherit",
                  textDecoration: "none",
                  "&:hover": { textDecoration: "underline" },
                }}
              >
                Refresh token
              </Link>
              .
            </Typography>
          </Box>

          <Box sx={{ mb: 2 }}>
            <Command
              number={2}
              options={{
                fontSize: { xs: 16 },
                dotColor: theme.palette.background.lightest,
              }}
            >
              Use cnspec to scan your Linux host
            </Command>
          </Box>
          <Box sx={{ pl: 6 }}>
            <Grid size={{ xs: 12, md: 6 }}>
              <Markdown source={`\`\`\`bash\n${LINUX_SCAN_COMMAND}\n\`\`\``} />
            </Grid>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
